// extracted by mini-css-extract-plugin
module.exports = {"containerform":"todoList_containerform__3nsK0","todoContainer":"todoList_todoContainer__1YY3Q","btn":"todoList_btn__12Lsp"};